import React, { useMemo, useState } from "react";

const LICENSED = [
  "", // ← blank = no state
  "FL","GA","MI","NJ","NC","OH","PA","SC","TX","MN","NY","VA","IL","AZ","WI","CT","CO","OK","CA","IN","DE","OR","MA","AL","MO","TN","KY","MD","LA","DC","NV","NE","MS","AR","KS","NM","WA",
];

const API_BASE = process.env.REACT_APP_INSURANCE_SCRAPER_URL || "http://localhost:4012";

export default function InsuranceLeadFeed() {
  const [keyword, setKeyword] = useState("i need life insurance");
  const [state, setState] = useState(""); // optional
  const [limit, setLimit] = useState(10);
  const [recentOnly, setRecentOnly] = useState(true);
  const [recentDays, setRecentDays] = useState(7);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [posts, setPosts] = useState([]);

  const sorted = useMemo(() => {
    const rank = (v) => (v === "good" ? 2 : v === "medium" ? 1 : 0);
    return [...(posts || [])].sort((a, b) => {
      if (rank(b.verdict) !== rank(a.verdict)) return rank(b.verdict) - rank(a.verdict);
      return (b.timestamp || 0) - (a.timestamp || 0);
    });
  }, [posts]);

  async function run() {
    setError("");
    setPosts([]);
    setLoading(true);

    try {
      const body = {
        keyword,
        limit: Number(limit) || 10,
        recentOnly,
        recentDays: Number(recentDays) || 7,
      };
      if (state) body.state = state; // only include if set

      const res = await fetch(`${API_BASE}/scrape`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await res.json().catch(() => null);
      if (!data) throw new Error("Server did not return JSON");
      if (!data.success) throw new Error(data.error || "Scrape failed");

      setPosts(Array.isArray(data.posts) ? data.posts : []);
    } catch (e) {
      setError(e?.message || "Unknown error");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ padding: 20, maxWidth: 1100, margin: "0 auto" }}>
      <h2 style={{ margin: 0 }}>Life Insurance Lead Scraper</h2>
      <p style={{ marginTop: 6, opacity: 0.8 }}>
        Calls <code>{API_BASE}/scrape</code>
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "2fr 1fr 1fr 1fr auto",
          gap: 10,
          alignItems: "end",
          padding: 12,
          border: "1px solid rgba(255,255,255,0.12)",
          borderRadius: 12,
          marginTop: 12,
        }}
      >
        <div>
          <label style={{ display: "block", fontSize: 12, opacity: 0.8 }}>Keyword</label>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder='e.g. "i need life insurance"'
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 10,
              border: "1px solid rgba(255,255,255,0.18)",
              background: "transparent",
              color: "inherit",
            }}
          />
        </div>

        <div>
          <label style={{ display: "block", fontSize: 12, opacity: 0.8 }}>State (optional)</label>
          <select
            value={state}
            onChange={(e) => setState(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 10,
              border: "1px solid rgba(255,255,255,0.18)",
              background: "transparent",
              color: "inherit",
            }}
          >
            {LICENSED.map((s) => (
              <option key={s || "ALL"} value={s} style={{ color: "#000" }}>
                {s ? s : "All"}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label style={{ display: "block", fontSize: 12, opacity: 0.8 }}>Limit</label>
          <input
            type="number"
            value={limit}
            onChange={(e) => setLimit(e.target.value)}
            min={1}
            max={200}
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 10,
              border: "1px solid rgba(255,255,255,0.18)",
              background: "transparent",
              color: "inherit",
            }}
          />
        </div>

        <div>
          <label style={{ display: "block", fontSize: 12, opacity: 0.8 }}>Recent days</label>
          <input
            type="number"
            value={recentDays}
            onChange={(e) => setRecentDays(e.target.value)}
            min={1}
            max={30}
            disabled={!recentOnly}
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 10,
              border: "1px solid rgba(255,255,255,0.18)",
              background: "transparent",
              color: "inherit",
              opacity: recentOnly ? 1 : 0.5,
            }}
          />
        </div>

        <button
          onClick={run}
          disabled={loading}
          style={{
            padding: "10px 14px",
            borderRadius: 10,
            border: "1px solid rgba(255,255,255,0.18)",
            background: "rgba(255,255,255,0.06)",
            color: "inherit",
            cursor: loading ? "not-allowed" : "pointer",
            whiteSpace: "nowrap",
          }}
        >
          {loading ? "Scraping..." : "Run Scrape"}
        </button>
      </div>

      <div style={{ marginTop: 10 }}>
        <label style={{ display: "inline-flex", gap: 8, alignItems: "center", cursor: "pointer" }}>
          <input
            type="checkbox"
            checked={recentOnly}
            onChange={(e) => setRecentOnly(e.target.checked)}
          />
          Recent posts only (uses FB filters param + a timestamp gate)
        </label>
      </div>

      {error ? (
        <div style={{ marginTop: 14, padding: 12, borderRadius: 12, border: "1px solid rgba(255,80,80,0.35)" }}>
          <b>Error:</b> {error}
        </div>
      ) : null}

      <div style={{ marginTop: 16, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ opacity: 0.85 }}>
          Results: <b>{sorted.length}</b>
        </div>

        {!!sorted.length && (
          <button
            onClick={() => {
              const blob = new Blob([JSON.stringify(sorted, null, 2)], { type: "application/json" });
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = `insurance-leads-${state || "ALL"}-${Date.now()}.json`;
              a.click();
              URL.revokeObjectURL(url);
            }}
            style={{
              padding: "8px 12px",
              borderRadius: 10,
              border: "1px solid rgba(255,255,255,0.18)",
              background: "transparent",
              color: "inherit",
              cursor: "pointer",
            }}
          >
            Download JSON
          </button>
        )}
      </div>

      <div style={{ marginTop: 10 }}>
        {sorted.map((p, idx) => (
          <div
            key={(p.permalink || "") + idx}
            style={{
              padding: 14,
              borderRadius: 14,
              border: "1px solid rgba(255,255,255,0.12)",
              marginBottom: 10,
            }}
          >
            <div style={{ display: "flex", gap: 12, justifyContent: "space-between", alignItems: "baseline" }}>
              <div style={{ fontWeight: 700, fontSize: 14 }}>
                {p.author || "Unknown"}{" "}
                <span style={{ fontWeight: 400, opacity: 0.7 }}>
                  • {p.verdict || "unknown"}
                  {p.timeLabel ? ` • ${p.timeLabel}` : ""}
                </span>
              </div>

              <div style={{ display: "flex", gap: 10 }}>
                {p.profileUrl ? (
                  <a href={p.profileUrl} target="_blank" rel="noreferrer" style={{ opacity: 0.9 }}>
                    Profile
                  </a>
                ) : null}
                {p.permalink ? (
                  <a href={p.permalink} target="_blank" rel="noreferrer" style={{ opacity: 0.9 }}>
                    Post
                  </a>
                ) : null}
              </div>
            </div>

            {p.reason ? (
              <div style={{ marginTop: 6, opacity: 0.75, fontSize: 12 }}>
                {p.reason}
              </div>
            ) : null}

            <div style={{ marginTop: 10, whiteSpace: "pre-wrap", lineHeight: 1.35 }}>
              {p.text || ""}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}